module.exports = __webpack_public_path__ + "img/C00024.2ae1ef0f.png";